<template>
<div class="container" id="main">
  <form>
    <div class="form-group">
      <label for="key">API Key</label>
      <textarea class="form-control" v-model="row.key" required placeholder="Paste token generated from property"></textarea>
    </div>
    <div class="form-group">
      <label for="property">Property</label>
      <select v-model="row.property" class="form-control" required id="property">
        <option v-for="property in properties" v-bind:value="property._id">
          {{ property.title }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label for="user">User</label>
      <select v-model="row.user" class="form-control" required id="user">
        <option v-for="user in users" v-bind:value="user._id">
          {{ user.name }}
        </option>
      </select>
    </div>
    <button type="submit" class="btn btn-primary" v-on:click.stop.prevent="save">Save</button>
    <button v-if="id" type="button" class="btn btn-danger ml-2" v-on:click.stop.prevent="remove">Delete</button>
  </form>
</div>
</template>
<script>
import {api} from '../api.js';
import ui from '../ui.js';
export default {
  name: 'Key',
  props: ['id'],
  data: function() {
    return {
      row: {
        title: '',
        url: '',
        logo: ''
      },
      properties:[],
      users: []
    }
  },
  mounted: function() {
    if (this.id) {
      this.fetch();
    }

    api.get('/properties', {
      params: {
        limit: 20
      }
    }).then((response) => {
      this.properties = response.data.docs;
    }).catch((error) => {
      ui.alert(error.response.data);
    });

    api.get('/users', {
      params: {
        limit: 500
      }
    }).then((response) => {
      this.users = response.data.docs;
    }).catch((error) => {
      ui.alert(error.response.data);
    });
  },
  methods: {
    fetch: function() {
      api.get('/keys/' + this.id, {
        params: {}
      }).then((response) => {
        this.row = response.data;
      }).catch((error) => {
        ui.alert(error.response.data);
      });
    },
    save: function() {
      if (this.id) {
        api.put('/keys/' + this.id, this.row).then((response) => {
          this.row = response.data;
          ui.alert('Saved');
        }).catch((error) => {
          ui.alert(error.response.data);
        });
      } else {
        api.post('/keys', this.row).then((response) => {
          this.row = response.data;
          this.$router.push('/keys/edit/' + this.row._id);
          ui.alert('Saved');
        }).catch(function(error) {
          ui.alert(error.response.data);
        });
      }
    },
    remove: function() {
      api.delete('/keys/' + this.id).then((response) => {
        this.$router.push('/keys');
      }).catch((error) => {
        ui.alert(error.response.data);
      });
    }
  }
}
</script>
